import type { ToastMessageOptions } from 'primevue/toast'
import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'
import ToastData = App.Data.ToastData

export function useToastMessages(): (messages: ToastData[]) => void {
  const { t } = useI18n({ useScope: 'global' })
  const toast = useToast()

  return (messages: ToastData[]): void => {
    messages.forEach((message, index) => {
      setTimeout(() => {
        toast.add({
          severity: message.severity as ToastMessageOptions['severity'],
          summary: t(`toasts.${message.key}.summary`),
          detail: t(`toasts.${message.key}.detail`),
          life: 5000,
        })
      }, index * 100)
    })
  }
}
